import React from "react";
import "./About.css";
const About = () => {
  return (
    <div
      className="w-10/12 mx-auto bg-about mt-32 mb-56"
    >
      <div id="about" className="grid gap-5 lg:grid-cols-2 grid-cols-1">
        <div>
          <div className="flex items-center mb-10">
            <span className="text-primary font-mono text-xl">01.</span>
            <h2 className="px-5 text-secondary font-bold text-2xl">About Me</h2>
            <hr className="w-2/6 border-gray-800 lg:block hidden" />
          </div>
          <p className="text-accent text-lg ">
            I'm a <span className="text-primary">Frontend Web Developer</span>{" "}
            building the Front-end of Websites and Web Applications that leads
            to the success of the overall product. Check out some of my work in
            the <span className="text-primary">Projects</span> section. <br />
          </p>
          <p className="my-5 text-accent text-lg ">
            I also like sharing content related to the stuff that I have learned
            over the years in{" "}
            <span className="text-primary"> Web Development</span> so it can
            help other people of the Dev Community. Feel free to Connect or
            Follow me on my{" "}
            <a href="" className="text-primary">
              {" "}
              Linkedin
            </a>{" "}
            where I post useful content related to Web Development and
            Programming
          </p>
          <p className="text-accent text-lg ">
            I'm open to <span className="text-primary"> Job </span>{" "}
            opportunities where I can contribute, learn and grow. If you have a
            good opportunity that matches my skills and experience then don't
            hesitate to <span className="text-primary"> contact </span> me.
          </p>
        </div>
        <div>
          <div className="flex items-center mb-10">
            <h2 className="pr-5 text-secondary font-bold text-2xl">
              Few technologies working
            </h2>
            <hr className="w-2/6 border-gray-800 md:block hidden" />
          </div>
          <div>
            <div className="flex flex-wrap">
              <div className=" rounded-sm font-mono font-normal border-primary border-dashed border-2 uppercase mx-2 text-accent py-4 md:py-5 my-2 px-6">
                JavaScript (ES6+)
              </div>
              <div className="border-primary border-dashed border-2 rounded-sm font-mono font-normal uppercase mx-2 text-accent py-4 md:py-5 my-2 px-6">
                React Js
              </div>
              <div className="border-primary border-dashed border-2 rounded-sm font-mono font-normal uppercase mx-2 text-accent py-4 md:py-5 my-2 px-6">
                Node.js
              </div>
              <div className="border-primary border-dashed border-2 rounded-sm font-mono font-normal  mx-2 text-accent py-4 md:py-5 my-2 px-6">
                Mongodb
              </div>
              <div className="border-primary border-dashed border-2 rounded-sm font-mono font-normal uppercase mx-2 text-accent py-4 md:py-5 my-2 px-6">
                TypeScript
              </div>
              <div className="border-primary border-dashed border-2 rounded-sm font-mono font-normal uppercase mx-2 text-accent py-4 md:py-5 my-2 px-6">
                Github
              </div>
              <div className="border-primary border-dashed border-2 rounded-sm font-mono font-normal uppercase mx-2 text-accent py-4 md:py-5 my-2 px-6">
                Responsive Design
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
